import type { Task } from '@portfolio-pm/shared';
import { X } from 'lucide-react';
import { TaskNotesMarkdown } from '../TaskDetailPanel.tsx';

export function TaskNotesWorkspace({
  task,
  onClose,
}: {
  task: Task;
  onClose(): void;
}): JSX.Element {
  return (
    <section
      data-testid="task-notes-workspace"
      aria-label="Notes workspace"
      className="absolute inset-x-0 bottom-0 z-40 flex h-[62%] min-h-72 flex-col border-t border-[color:var(--app-border-strong)] bg-[color:var(--app-workspace)] shadow-[0_-12px_32px_rgb(0_0_0_/_0.16)]"
    >
      <header className="flex shrink-0 items-center justify-between gap-3 border-b border-[color:var(--app-border)] px-4 py-3">
        <div className="min-w-0">
          <p className="text-xs font-medium uppercase tracking-wide text-[color:var(--app-text-soft)]">
            Notes workspace
          </p>
          <h2 className="truncate text-base font-medium">{task.title}</h2>
        </div>
        <button
          type="button"
          onClick={onClose}
          className="ui-button ui-button-subtle h-8 gap-1 px-2 text-xs"
        >
          <X aria-hidden="true" size={14} />
          Close workspace
        </button>
      </header>
      <div className="min-h-0 flex-1 overflow-y-auto p-4">
        {task.notes?.trim() ? (
          <TaskNotesMarkdown notes={task.notes} className="mx-auto max-w-3xl" />
        ) : (
          <p className="text-sm text-[color:var(--app-text-soft)]">No notes yet.</p>
        )}
      </div>
    </section>
  );
}
